import {createBrowserHistory} from 'history';

export const history = createBrowserHistory({
  basename: `/event/${window.event_id}`,
});
